import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { isDemoMode } from '../config/environment';

export default function LoginPage() {
    // 修复：将初始状态设置为空字符串
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();
    const { t } = useTranslation();
    const backgroundImageStyle = {
        backgroundImage: "url('/loginPage_cat.png')",
        backgroundPosition: 'left center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            await login(username, password);
        } catch (err) {
            setError(err.message || t('unknownError'));
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <div className="relative min-h-screen flex flex-col md:flex-row overflow-hidden" style={backgroundImageStyle}>
            <div className="absolute inset-0 bg-slate-900/10 md:bg-slate-900/20" aria-hidden="true"></div>
            <div className="relative w-full h-64 md:h-auto md:flex-none md:w-[61.8%]">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-white/40 md:to-white/30" aria-hidden="true"></div>
            </div>
            <div className="relative w-full md:flex-none md:w-[38.2%] flex items-center justify-center p-6 md:p-12 bg-white/30 backdrop-blur-lg">
                <div className="w-full max-w-md">
                    <div className="text-center mb-8">
                        <h1 className="text-4xl font-bold text-gray-800">{t('systemTitle')}</h1>
                    </div>
                    <div className="bg-white/70 backdrop-blur-sm p-8 rounded-xl shadow-lg">
                        <h2 className="text-2xl font-semibold text-center text-gray-700 mb-6">{t('userLogin')}</h2>
                        {isDemoMode && (
                            <div className="mb-5 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
                                <div className="font-semibold mb-1">Demo accounts</div>
                                <div className="grid grid-cols-1 gap-1">
                                    <span>demo_admin / demo1234</span>
                                    <span>demo_sales / demo1234</span>
                                    <span>demo_residence / demo1234</span>
                                    <span>demo_accounting / demo1234</span>
                                </div>
                            </div>
                        )}
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="username-input" className="block text-sm font-medium text-gray-700 mb-1">
                                    {t('username')}
                                </label>
                                <input 
                                    id="username-input"
                                    type="text"
                                    required
                                    placeholder={t('usernamePlaceholder')}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <div>
                                <label htmlFor="password-input" className="block text-sm font-medium text-gray-700 mb-1">
                                    {t('password')}
                                </label>
                                <input 
                                    id="password-input"
                                    type="password"
                                    required
                                    placeholder={t('passwordPlaceholder')}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            
                            {error && (
                                <div className="text-center p-3 bg-error-50 border border-error-200 text-error-700 rounded-lg text-sm font-medium flex items-center justify-center space-x-2">
                                    <svg className="w-4 h-4 text-error-500" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                    <span>{error}</span>
                                </div>
                            )}

                            <div>
                                <button 
                                    type="submit" 
                                    disabled={isLoading} 
                                    className="w-full py-3 px-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 active:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                                >
                                    {isLoading ? (
                                        <div className="flex items-center justify-center space-x-2">
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                            <span>{t('loggingIn')}</span>
                                        </div>
                                    ) : (
                                        t('login')
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
